import { currentCompany } from '../../actionTypes';

const initialState = {
  requestInProgress: false,
  loading: false,
  state: null,
  success: false,
  error: false,
};

export default function craftsmanCertification(state = initialState, action) {
  switch (action.type) {
    case currentCompany.craftsman.get.start:
      return {
        ...state,
        state: null,
        loading: true,
        success: false,
        error: false,
      };

    case currentCompany.craftsman.get.end:
      return {
        ...state,
        loading: false,
        state: action.payload.state,
      };

    case currentCompany.craftsman.update.start:
      return { ...state, requestInProgress: true, loading: true };

    case currentCompany.craftsman.update.end:
      return {
        ...state,
        requestInProgress: false,
        state: action.payload.state,
        loading: false,
        success: true,
        error: false,
      };

    case currentCompany.craftsman.update.error:
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      };

    default:
      return state;
  }
}
